import { clientConstants } from './client.constants'

const initialState = {
  boats: [],
  client: null,
  loadingClientsForUser: false,
  clientsForUser: [],
  clientsForUserError: null,
  clientAdmins: [],
  clientAccessGroups: [],
  loading: false,
  error: null,
}

export function client(state = initialState, action) {
  switch (action.type) {
    case clientConstants.FETCH_BOATS_FOR_CLIENT_SUCCESS:
      return {
        ...state,
        boats: action.boats,
        loading: false,
      }
    case clientConstants.FETCH_CLIENT_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        client: action.client,
      }
    case clientConstants.FETCH_ADMIN_CLIENTS_FOR_USER_LOADING:
      return {
        ...state,
        loadingClientsForUser: true,
        clientsForUserError: null,
      }
    case clientConstants.FETCH_ADMIN_CLIENTS_FOR_USER_SUCCESS:
      return {
        ...state,
        loadingClientsForUser: false,
        clientsForUser: action.clients,
      }
    case clientConstants.FETCH_ADMIN_CLIENTS_FOR_USER_ERROR:
      return {
        ...state,
        loadingClientsForUser: false,
        clientsForUserError: action.error,
      }
    case clientConstants.FETCH_CLIENT_USER_LINKS_ADMIN_SUCCESS:
      return {
        ...state,
        loading: false,
        clientAdmins: action.clientAdmins,
      }
    case clientConstants.FETCH_CLIENT_USER_LINKS_SUCCESS: {
      const updatedAccesGroupUsers = state.clientAccessGroups.map((item, index) => {
        if (item.clientAccessGroupId !== action.accessGroupId) {
          // This isn't the item we care about - keep it as-is
          return item
        }

        // Otherwise, this is the one we want - return an updated value
        return { ...item, userLinks: action.ClientUserLinks }
      })
      return {
        ...state,
        clientAccessGroups: updatedAccesGroupUsers,
        loading: false,
      }
    }

    case clientConstants.FETCH_BOATS_FOR_ACCESS_GROUP_SUCCESS: {
      const updatedAccessGroupBoats = state.clientAccessGroups.map((item, index) => {
        if (item.clientAccessGroupId !== action.accessGroupId) {
          return item
        }
        return { ...item, clientAccessGroupBoatLinks: action.accessBoatLinks }
      })
      return {
        ...state,
        clientAccessGroups: updatedAccessGroupBoats,
        loading: false,
      }
    }
    case clientConstants.CREATE_BOAT_ACCESS_LINK_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case clientConstants.CREATE_NEW_BOAT_USER_LINK_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case clientConstants.FETCH_BOAT_USER_LINKS_SUCCESS: {
      const updatedClientBoats = state.boats.map((item, index) => {
        if (item.boatId !== action.boatId) {
          return item
        }
        return { ...item, boatUserLinks: action.boatUserLinks }
      })
      return {
        ...state,
        boats: updatedClientBoats,
        loading: false,
      }
    }
    case clientConstants.SAVING_NEW_CLIENT_USER_LINK_SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case clientConstants.SAVING_NEW_USER_SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case clientConstants.FETCH_CLIENT_ACCESS_GROUPS_SUCCESS:
      return {
        ...state,
        loading: false,
        clientAccessGroups: action.clientAccessGroups,
      }

    case clientConstants.CREATE_NEW_CLIENT_ACCESS_GROUP_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    //DEFAULT BEHAVIOUR
    case clientConstants.REQUEST_START:
      return {
        ...state,
        error: null,
        loading: true,
      }

    case clientConstants.REQUEST_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      }
    default:
      return state
  }
}
